import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { Subscription } from "rxjs/Subscription";
import { MatDialog, MatPaginator, MatTooltip } from "@angular/material";
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import { ResultDialogComponent } from "../result-dialog/result-dialog.component";
import { EditTollPassComponent } from "../edit-toll-pass/edit-toll-pass.component";
import { AddTollPassDialogComponent } from "../add-toll-pass-dialog/add-toll-pass-dialog.component";
import { ShowCodeDialogComponent } from "../show-code-dialog/show-code-dialog.component";

import { MdDialogFix } from "../md-dialog-fix";

import {
  AuthGuardService,
  CommercialService,
  DialogService,
  LoadingService,
  UserService,
} from "@core/services";
import {
  AccountPassDatabase,
  AccountPassDataSource,
  User,
} from "@shared/models";
import { FilterCardStatePipe } from "@shared/pipes";

import { fadeAnimation } from "../../app.animations";

declare var pdfMake: any;

@Component({
  selector: "app-edit-account-cards",
  templateUrl: "./edit-account-cards.component.html",
  styleUrls: ["./edit-account-cards.component.css"],
  providers: [],
  animations: [fadeAnimation],
})
export class EditAccountCardsComponent implements OnInit, OnDestroy {
  private pdf: any;
  user: User;
  commercial: any;
  selectedOption: string;

  subscription: Subscription;
  commercialSubscription: Subscription;

  passesFound = true;
  displayedColumns = [
    "passType",
    "passName",
    "passEdit",
    "passReplace",
    "passDelete",
    "passStatus"
  ];
  accountDatabase: AccountPassDatabase;
  dataSource: AccountPassDataSource | null;
  showLoader: boolean;
  pageLoading: boolean;

  passResult: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private _userService: UserService,
    private _authGuard: AuthGuardService,
    private _dialogService: DialogService,
    public dialog: MatDialog,
    private _commercialService: CommercialService,
    private router: Router,
    private _loadingService: LoadingService,
    private _filterCardStatePipe: FilterCardStatePipe
  ) {}

  ngOnInit() {
    this.showLoader = true;
    this.commercialSubscription = this._commercialService
      .getCommercialValue()
      .subscribe((commercial) => {
        this.commercial = commercial;
      });
    this.subscription = this._userService.getUser().subscribe((user) => {
      this.user = user;
      if (this.user.accountSummaryArray) {
        if (this.user.accountSummaryArray.length > 0) {
          let passData = this.getAccountPasses();
        }
      }
    });
    this._loadingService
      .getHiddenValue()
      .subscribe((value) => (this.pageLoading = !value));
  }

  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    if (this.subscription) this.subscription.unsubscribe();
    if (this.commercialSubscription) this.commercialSubscription.unsubscribe();
  }

  deletePass(index: number) {
    this.openDeleteDialog(index);
  }

  reopenPass(pass) {
    this.openReopenPassDialog(pass);
  }

  editPass(index: number) {
    const editTollPassDialog = this.dialog.open(EditTollPassComponent);
    editTollPassDialog.componentInstance.passId = index;

    // Needed to fix dialog opening closing issue on older iOS devices
    editTollPassDialog.afterOpen().subscribe(MdDialogFix);

    editTollPassDialog.afterClosed().subscribe((result) => {
      this.selectedOption = result;
      console.log("edit pass result", result);
      if (result) {
        this.getAccountPasses();
      }
    });
  }

  replacePass(index: number) {
    this.openReplaceDialog(index);
  }

  displayCode() {
    if (
      this.user.accountSummaryArray[this.user.accountIndex].AccountBalance == 0
    ) {
      let dialogRef = this.dialog.open(ResultDialogComponent, {
        data: {
          title: "Insufficient Balance",
          message: "Please process a payment before linking your Nexus.",
          alertType: "primary",
        },
      });

      // Needed to fix dialog opening closing issue on older iOS devices
      dialogRef.afterOpen().subscribe(MdDialogFix);

      dialogRef
        .afterClosed()
        .subscribe((date) => this.router.navigate(["/makepayment"]));
    } else {
      let accountId = this.user.accountSummaryArray[this.user.accountIndex].id;
      const showCode = this.dialog.open(ShowCodeDialogComponent, {
        data: { accountId: accountId },
      });
      // Needed to fix dialog opening closing issue on older iOS devices
      showCode.afterOpen().subscribe(MdDialogFix);
    }
  }

  getAccountPasses() {
    //console.log("Reacheddddddd");
    this._userService.emptyAccountPassArray();
    const accountPassUrl = "portfolios/AccountCards";
    const accountPassCommercialUrl = "portfolios/AccountCardsCommercial";
    let data: string;
    let url: string;

    url = accountPassUrl;
    data = JSON.stringify({
      AccountId: this.user.accountSummaryArray[this.user.accountIndex].id,
      CardId: 0,
    });

    if (this.commercial) {
      console.log("isCommercial:" + this.commercial.isCustomerCommercial);
      if (this.commercial.isCustomerCommercial) {
        url = accountPassCommercialUrl;
        data = JSON.stringify({
          AccountId: this.user.accountSummaryArray[this.user.accountIndex].id,
          CustomerId: this.user.customerIdArray[this.user.customerIndex].Id,
        });
        this.displayedColumns = [
          "passType",
          "passName",
          "passClass",
          "passEdit",
          "passReplace",
          "passDelete",
          "passStatus"
        ];
      } else {
        if (this.user.isCustomerService) {
          this.displayedColumns = [
            "passType",
            "passName",
            "passEdit",
            "passReplace",
            "passDelete",
            "passStatus",
            "evStatus"
          ]; 
        } else {
          this.displayedColumns = [
            "passType",
            "passName",
            "passEdit",
            "passReplace",
            "passDelete",
            "passStatus"
          ]; 
        }
      }
    } else {

      if (this.user.isCustomerService) {
        this.displayedColumns = [
          "passType",
          "passName",
          "passEdit",
          "passReplace",
          "passDelete",
          "passStatus",
          "evStatus"
        ]; 
      } else {
        this.displayedColumns = [
          "passType",
          "passName",
          "passEdit",
          "passReplace",
          "passDelete",
          "passStatus"
        ]; 
      }
    }
    this._authGuard.authenticatedPost(url, data).subscribe(
      (result) => {
        if (!this.user.isCustomerService)
          this.passResult = this._filterCardStatePipe.transform(
            result,
            "active"
          );
        else this.passResult = result;

        console.log(this.passResult);
        this.accountDatabase = new AccountPassDatabase(this.passResult);
        this.paginator.length = this.accountDatabase.data.length;
        this.dataSource = new AccountPassDataSource(
          this.accountDatabase,
          this.paginator
        );
        console.log(this.dataSource);
        for (const pass of this.passResult) {
          if (this.commercial.isCustomerCommercial) {
            this._userService.addCommercialPass(
              pass.cardid,
              pass.cardname,
              pass.cardtypeid,
              pass.ccnumber,
              pass.closeddt,
              pass.description
            );
          } else {
            this._userService.addPass(
              pass.cardid,
              pass.cardname,
              pass.cardtypeid,
              pass.ccnumber,
              pass.closeddt,
              pass.evexiprydt
            );
          }
        }

        if (this.user.accountPassArray.length === 0) {
          this.passesFound = false;
        } else {
          this.passesFound = true;
        }

        this.showLoader = false;
        return this.passResult;
      },
      (error) => {
        console.log("Error: " + error);
        return {};
      }
    );
  }

  openReopenPassDialog(pass) {
    const message = `Are you sure you want to reopen this pass?`;

    let dialogRef = this._dialogService
      .confirm("Reopen Account Pass", message)
      .subscribe((res) => {
        if (!res) return;
        const payload = { PassId: pass.id };
        const endpoint = "portfolios/ReopenAccountCard";

        this._authGuard.authenticatedPost(endpoint, payload).subscribe(
          (success) => this.getAccountPasses(),
          (error) => console.log("error reopen account pass")
        );
      });
  }

  openDeleteDialog(index) {
    this._dialogService
      .confirm("Delete Pass", "Are you sure you want to delete this pass?")
      .subscribe((res) => {
        if (res) {
          const deletePassUrl = "portfolios/DeleteAccountCard";
          let data: string;

          data = JSON.stringify({
            PassId: this.user.accountPassArray[index].id,
            AccountId: this.user.accountSummaryArray[this.user.accountIndex].id,
          });
          this._authGuard.authenticatedPost(deletePassUrl, data).subscribe(
            (result: any) => {
              if (result.Message && result.Message == "Unauthorized.") {
                this.dialog.open(ResultDialogComponent, {
                  data: {
                    message: result.Message,
                    alertType: "danger",
                    title: "Failed to Delete Card",
                  },
                });
              } else {
                this.user.deletePass(index);
                this.getAccountPasses();
              }
            },
            (error) => console.log("Error: " + error)
          );
        }
      });
  }

  openReplaceDialog(index) {
    // console.log(this.user.accountPassArray[index].passType)
    if (
      this.user.accountPassArray[index].passType == "1" &&
      !this.user.isCustomerService
    ) {
      let dialogRef = this.dialog.open(ResultDialogComponent, {
        data: {
          message:
            "Sorry, we no longer offer Nexpress Toll Cards. Please add Window Tags or a Nexus card instead. Please contact customer service if you have any questions.",
          alertType: "primary",
          title: "Toll Cards Deprecated",
        },
      });

      // Needed to fix dialog opening closing issue on older iOS devices
      dialogRef.afterOpen().subscribe(MdDialogFix);

      return;
    }
    this._dialogService
      .confirm("Replace Pass", "Are you sure you want to replace this pass?")
      .subscribe((res) => {
        console.log(res);
        if (res) {
          console.log("replace pass number", index);
          const ReplacePassUrl = "portfolios/ReplacePass";
          let data: string;

          data = JSON.stringify({
            AccountId: this.user.customerIdArray[this.user.customerIndex].Id,
            PassId: this.user.accountPassArray[index].id,
          });
          this._authGuard.authenticatedPost(ReplacePassUrl, data).subscribe(
            (result) => {
              console.log("Card Replaced");
              this.getAccountPasses();
            },
            (error) => console.log("Error: " + error)
          );
        }
      });
  }

  confirmDate(index, passName: string, passNumber: string, passEVExpiraton: string, $event: MatDatepickerInputEvent<Date>) {
    console.log($event);
    console.log(passEVExpiraton);
    console.log(`Pass Name: ${passName} Pass Number: ${passNumber} Date: ${$event.value}`);
    if ($event.value) {
      this._dialogService.confirm("Enable EV Status", `Are you sure you would like to enable EV status on pass ${passName} ${passNumber} and set its expiration to ${$event.value.toLocaleDateString()}?`)
      .subscribe((res) => {
        console.log(res)
        if (res == true) {
          //construct and send update to api
          var data = JSON.stringify({
            AccountId: this.user.customerIdArray[this.user.customerIndex].Account.Id,
            PassId: this.user.accountPassArray[index].id,
            PassExpiration: $event.value.toLocaleDateString()
          });

          const EVPassUrl = "CustomerService/UpdatePassEVStatus";
          this._authGuard.authenticatedPost(EVPassUrl, data).subscribe(
            (result) => {
              console.log("Card EV Status Updated");
              this.getAccountPasses();
            },
            (error) => console.log("Error: " + error)
          );
        } else {
          //clear datepicker
          if (!passEVExpiraton || passEVExpiraton == null || passEVExpiraton == "") {
            $event.target.value = undefined;
          }
          if(passEVExpiraton) {
            $event.target.value = new Date(passEVExpiraton);
          }
        }
      });
    } else {
      this._dialogService.confirm("Disable EV Status", `Are you sure you would like to disable EV status on pass ${passName} ${passNumber} ?`)
      .subscribe((res) => {
        console.log(res)
        if (res == true) {
          //construct and send update to api
          var data = JSON.stringify({
            AccountId: this.user.customerIdArray[this.user.customerIndex].Account.Id,
            PassId: this.user.accountPassArray[index].id
          });

          const EVPassUrl = "CustomerService/DisablePassEVStatus";
          this._authGuard.authenticatedPost(EVPassUrl, data).subscribe(
            (result) => {
              console.log("Card EV Status Updated");
              this.getAccountPasses();
            },
            (error) => console.log("Error: " + error)
          );
        } else {
          if(passEVExpiraton) {
            $event.target.value = new Date(passEVExpiraton);
          }
        }
    })
    }
  }

  setImage(passType: number) {
    if (passType === 3) {
      return "nexus_card_small.jpg";
    } else if (passType === 5) {
      return "windshield_tag1.png";
    } else {
      return "nexpress_card_small.png";
    }
  }

  formatPassNumber(passNumber: string, passType) {
    
    // Return the last 10 word characters, ignoring front padded zeros.
    passNumber = passNumber.replace(/\b0+/, "")
    if (+passType == 5 && (this.commercial.isCustomerCommercial == null || this.commercial.isCustomerCommercial == undefined || this.commercial.isCustomerCommercial == false || this.commercial.isCustomerCommercial == true)) {
      if (passNumber.length != 10){
        //passNumber = passNumber.slice(0, -1);
      }
    }
    
    passNumber = passNumber.substr(-13).replace(/\b0+/, "");

    return passNumber;
  }

  isPending(passNumber: string) {
    return passNumber.startsWith("9");
  }

  isClosed(value: any) {
    if (!value) return false;
    let date = new Date(value);
    let now = new Date();
    return now >= date;
  }

  public updateAccountPassArray(event) {
    this.getAccountPasses();
  }

  addTollPass() {
    const addTollPassComponent = this.dialog.open(AddTollPassDialogComponent, {
      width: "600px",
    });

    // Needed to fix dialog opening closing issue on older iOS devices
    addTollPassComponent.afterOpen().subscribe(MdDialogFix);

    addTollPassComponent.afterClosed().subscribe((result) => {
      if (result) {
        this.getAccountPasses();
      }
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/edit-account-cards/edit-account-cards.component.ts